module.exports = __webpack_public_path__ + "media/images/door-sticker2-03e6c98f3c226b922d433add393efd62.jpeg";